import cx from 'classnames';
import { PropsWithChildren, FC, forwardRef } from 'react';
import { CatDrawer } from '@blocks-react/components/Drawer';
import type { drawerProps } from '../../../hooks';
import { Conditional } from '../conditional';
import styles from './styles.module.scss';

export const Drawer: FC<PropsWithChildren<drawerProps>> = forwardRef(
  ({ children, className, preserveContent = false, ...drawerProps }, ref) => (
    <CatDrawer
      {...drawerProps}
      className={cx(styles['drawer'], className)}
      preserveContent={preserveContent}
      ref={ref}
    >
      <Conditional test={preserveContent || !!drawerProps.isActive}>
        {children}
      </Conditional>
    </CatDrawer>
  )
);
